// extracted by mini-css-extract-plugin
export var dropdown = "_tc-0";
export var imageWrapper = "_tc-3";
export var itemNameContainer = "_tc-1";
export var productImage = "_tc-2";
export var spinnerWrapper = "_tc-4";